import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Media from 'sb-media'
import constants from 'common/helpers/constants'

import CommonButton from 'components/buttons/CommonButton/CommonButton'
import Modal from 'components/modal/Modal/Modal'

import s from './BackNextModal.scss'


const BackNextModal = (props) => {
  const {
    children, className, name, title, titleNode, titleUppercase, subText,
    showCloseButton, fullWidth, disableClose, disableCloseOverlay,
    nextButtonId, dataTestId,
    onClose, onBack, onNext,
  } = props

  const isBackButtonVisible = Boolean(onBack)
  const isNextButtonVisible = Boolean(onNext)

  const controlsClassName = cx(s.controls, {
    [s.soloBtn]: !isBackButtonVisible || !isNextButtonVisible,
  })

  const modalProps = {
    className,
    name,
    title,
    titleNode,
    titleUppercase,
    subText,
    showCloseButton,
    fullWidth,
    disableClose,
    disableCloseOverlay,
    onClose,
  }

  return (
    <Modal {...modalProps}>
      <div className={s.content} data-testid={dataTestId}>
        {children}
      </div>
      <div className={controlsClassName}>
        {
          isBackButtonVisible && (
            <Media mobile>
              {
                (isMobile) => (
                  <CommonButton
                    lg={!isMobile}
                    md={isMobile}
                    back
                    emptyGray
                    fullWidthOnMobile={!isNextButtonVisible}
                    dataTestId={constants.testIds.modal.goBackBtn}
                    onClick={onBack}
                  />
                )
              }
            </Media>
          )
        }
        {
          isNextButtonVisible && (
            <Media mobile>
              {
                (isMobile) => (
                  <CommonButton
                    id={nextButtonId}
                    lg={!isMobile}
                    md={isMobile}
                    next
                    brand
                    fullWidthOnMobile={!isBackButtonVisible}
                    dataTestId={constants.testIds.modal.goNextBtn}
                    onClick={onNext}
                  />
                )
              }
            </Media>
          )
        }
      </div>
    </Modal>
  )
}

BackNextModal.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  title: PropTypes.any,
  titleNode: PropTypes.node,
  titleUppercase: PropTypes.bool,
  subText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  showCloseButton: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disableClose: PropTypes.bool,
  disableCloseOverlay: PropTypes.bool,
  nextButtonId: PropTypes.string,
  dataTestId: PropTypes.string,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onClose: PropTypes.func.isRequired,
}


export default BackNextModal
